import React from 'react';
import ContratantesList from './ContratantesList';

const ContratantesManager = () => {
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Gestión de Contratantes</h1>
        <p className="text-gray-600">Administra los contratantes y sus cotizaciones</p>
      </div>
      <ContratantesList mode="manage" />
    </div>
  );
};

export default ContratantesManager;